import { Grid, Typography } from '@material-ui/core';
import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { saveWorkday } from '../../redux/timecard';
import HoursInput from '../../components/HoursInput';
import { hourFields } from '../../config/staticValues';
import { debounce } from '../../redux/hooks/use-debounce';
import dateUtil from '../../util/dateUtil';
import { getClockedHoursTotal, getProcHoursBreakdown } from '../../util/helperFunctions';
import { timecardWorkdayStyles } from './style';

const WorkdayHoursForm = ({ workday, entries, disabled, onUpdate }) => {
  const dispatch = useDispatch();
  const classes = timecardWorkdayStyles();
  const [localWorkday, setLocalWorkday] = useState(workday);
  const { serviceHours } = getProcHoursBreakdown(entries);
  const clockedHours = getClockedHoursTotal(localWorkday);
  const updateField = (value, field) => {
    if (localWorkday[field] !== value) {
      const newWorkday = Object.assign({}, localWorkday);
      newWorkday[field] = value;
      setLocalWorkday(newWorkday);
      if (value != undefined) updateServer(newWorkday);
      if (onUpdate) {
        onUpdate(newWorkday);
      }
    }
  };
  const updateServer = useCallback(
    debounce((data) => {
      dispatch(saveWorkday(data));
    }, 2000),
    [workday]
  );

  return (
    <Grid container className={classes.headerContent}>
      <Grid item xs={2} className={classes.headerContent}>
        <span>
          <Typography className={classes.dayText}>
            {dateUtil.stringToDateFormat(workday.workDate, 'EEEE')}
          </Typography>
          <Typography>
            {dateUtil.stringToDateFormat(workday.workDate, 'LLL do')}
          </Typography>
        </span>
      </Grid>
      <Grid item xs={7}>
        <Grid container>
          {hourFields.map((field, index) => (
            <Grid key={index} item xs={3}>
              <HoursInput
                limitHours={true}
                label={field.label}
                value={localWorkday[field.id] != null ? localWorkday[field.id] : ''}
                setValue={(value) => updateField(value, field.id)}
                disabled={disabled}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid item xs={3} className={classes.readOnlyData}>
        <Grid container>
          <Grid item xs={4}>
            <HoursInput label="Clocked" value={clockedHours} disabled />
          </Grid>
          <Grid item xs={4}>
            <HoursInput label="Service" value={serviceHours} disabled />
          </Grid>
          <Grid item xs={4}>
            <HoursInput
              label="Bonus"
              value={(
                parseFloat(workday.bonusHoursOver38) + parseFloat(workday.bonusHours)
              ).toFixed(2)}
              disabled
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default WorkdayHoursForm;
